"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloodInsuranceRejectionReason = exports.FloodInsuranceReviewResult = void 0;
/**
 * Outcome of an ops/system review of a flood-insurance declarations page. Canonical here in aven_types
 * so the backend entity (`FloodInsuranceDocument.documentReviewResult`), the API contract, and the
 * partner dashboard share one source of truth. String values are byte-identical to the backend
 * `FloodInsuranceDocumentReviewResult` enum — keep them in sync.
 */
var FloodInsuranceReviewResult;
(function (FloodInsuranceReviewResult) {
    FloodInsuranceReviewResult["accepted"] = "accepted";
    FloodInsuranceReviewResult["rejected"] = "rejected";
})(FloodInsuranceReviewResult || (exports.FloodInsuranceReviewResult = FloodInsuranceReviewResult = {}));
/**
 * Structured reasons a flood-insurance policy was rejected during review. The string values are
 * byte-identical to the backend `FLOOD_DOC_REVIEW_FAIL_REASONS` map values (which are what's persisted
 * in `flood_insurance.rejection_reasons`), so the dashboard can read the stored strings directly. These
 * mirror what ops requests from the borrower (correct loss payee, NFIP-compliant policy, correct flood
 * zone, etc.). Surfaced in the partner-dashboard flood click-in so the LO sees exactly what's wrong.
 *
 * Note: `missingDocument` is a dashboard-only synthetic reason (never sent to the borrower); the
 * `toBeRenewedIn60Days` value is retained because it still appears on historical rows.
 */
var FloodInsuranceRejectionReason;
(function (FloodInsuranceRejectionReason) {
    FloodInsuranceRejectionReason["wrongDocument"] = "wrong_doc_type";
    FloodInsuranceRejectionReason["wrongLossPayee"] = "wrong_loss_payee";
    FloodInsuranceRejectionReason["incorrectAddress"] = "address_mismatch";
    FloodInsuranceRejectionReason["incorrectPropertyDescription"] = "property_description_mismatch";
    FloodInsuranceRejectionReason["incorrectFloodZone"] = "flood_zone_mismatch";
    FloodInsuranceRejectionReason["incorrectNameOnThePolicy"] = "applicant_name_mismatch";
    FloodInsuranceRejectionReason["deductibleTooHigh"] = "deductible_too_high";
    FloodInsuranceRejectionReason["insufficientCoverageAmount"] = "coverage_too_low";
    FloodInsuranceRejectionReason["toBeRenewedIn60Days"] = "expiring_in_60_days";
    FloodInsuranceRejectionReason["toBeNFIPCompliant"] = "nfip_noncompliance";
    FloodInsuranceRejectionReason["missingDocument"] = "missing document";
})(FloodInsuranceRejectionReason || (exports.FloodInsuranceRejectionReason = FloodInsuranceRejectionReason = {}));
